import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f933682"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "add-tenant"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "诊所名称：", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "租户名称：", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_7 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_8 = {
  class: "pagination-box"
};
import { ref, watch } from 'vue';
import wxInfo from './WxInfo';
import { getClinicIntroPage } from '@/api/tenant';
import { tableDataSchemas } from './config';
import TenantSelect from '@/components/TenantSelect';
import { Refresh, Search } from '@element-plus/icons-vue';
export default {
  __name: 'ClinicContent',
  props: {
    activeName: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;

    // 数据相关
    const allTenantData = ref([]);
    const total = ref(0);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const loading = ref(false);
    const tenantId = ref('');
    const name = ref('');
    const getAllTenant = async () => {
      loading.value = true;
      const res = await getClinicIntroPage({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        tenantId: tenantId.value,
        name: name.value
      });
      allTenantData.value = res.records;
      total.value = res.total;
      loading.value = false;
    };
    const handleRefreshActivity = () => {
      currentPage.value = 1;
      tenantId.value = '';
      name.value = '';
      getAllTenant();
    };
    watch(() => props.activeName, val => {
      if (val === '租户信息') return;
      getAllTenant();
    }, {
      immediate: true
    });
    const handleCurrentChange = val => {
      currentPage.value = val;
      getAllTenant();
    };
    const isVisible = ref(false);
    const currentModel = ref(null);
    const handleEditClinicInfo = row => {
      currentModel.value = row;
      isVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
          placeholder: "请输入租户名",
          style: {
            "width": "200px"
          }
        }, null, 8, ["modelValue"]), _hoisted_4, _hoisted_5, _createVNode(_unref(TenantSelect), {
          modelValue: tenantId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tenantId.value = $event)
        }, null, 8, ["modelValue"]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getAllTenant
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        },
        class: "flex-1"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: allTenantData.value,
          "row-key": "id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            width: "80"
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableDataSchemas), (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              prop: item.prop,
              label: item.label,
              "min-width": item.minWidth
            }, null, 8, ["prop", "label", "min-width"]);
          }), 128)), _createVNode(_component_el_table_column, {
            label: "操作",
            type: "index",
            "min-width": "80"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => handleEditClinicInfo(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['clinicUpdate']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(wxInfo), {
        model: currentModel.value,
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => isVisible.value = $event),
        onRefreshData: getAllTenant,
        onClearModel: _cache[3] || (_cache[3] = $event => currentModel.value = null)
      }, null, 8, ["model", "modelValue"])], 64);
    };
  }
};